var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTubeShortsBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 450",
    style: {
      enableBackground: "new 0 0 600 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M392.6,198.8l-19.2-8l22.9-12.2c29.3-15.5,40.5-51.8,25-81.1c-15.5-29.3-51.8-40.5-81.1-25L204,144.7 c-29.3,15.3-40.7,51.5-25.4,80.9c6.3,12.1,16.6,21.7,29.1,27.1l19.2,7.9L204,272.7c-28.9,16.3-39.1,53-22.8,81.9 c15.7,27.8,50.3,38.5,78.9,24.4l136.2-72.1c29.3-15.3,40.7-51.5,25.4-80.9C415.3,213.9,405.1,204.3,392.6,198.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "268.1,268.2 348.2,225.8 268.1,183.3  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeShortsBlack);
export default __webpack_public_path__ + "static/media/YouTube-Shorts-Black.223035758b06c041f9a73978f38efba4.svg";
export { ForwardRef as ReactComponent };